// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider{border-color:#bdbdbd}.v-expansion-panel{border:1px solid #e0e0e0;border-radius:10px!important}.v-expansion-panel:before{box-shadow:none!important}.v-expansion-panel:after{border-top:none!important}.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap{padding:0}.v-overlay--active{touch-action:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
